const POINTER_OFFSET_PX = 14;
const VIEWPORT_MARGIN_PX = 8;
const LINE_HEIGHT_PX = 18;
const VERTICAL_PADDING_PX = 20;

// Matches the max-width of the tooltip box in PillBarList.module.css (22rem).
export const TOOLTIP_MAX_WIDTH_PX = 352;

// The box isn't measured before it is placed, so its height is estimated from
// the number of lines it will hold.
export const estimateTooltipHeight = (lineCount: number): number =>
  lineCount * LINE_HEIGHT_PX + VERTICAL_PADDING_PX;

interface PlacementInput {
  height: number;
  viewportHeight: number;
  viewportWidth: number;
  width: number;
  x: number;
  y: number;
}

// Puts a tooltip just below and right of the pointer, then keeps it fully on
// screen: pulled back from the right edge, never past the left edge, and
// flipped above the pointer when it would run off the bottom.
export const placeTooltip = ({
  height,
  viewportHeight,
  viewportWidth,
  width,
  x,
  y,
}: PlacementInput): { left: number; top: number } => {
  const left = Math.max(
    VIEWPORT_MARGIN_PX,
    Math.min(x + POINTER_OFFSET_PX, viewportWidth - width - VIEWPORT_MARGIN_PX)
  );
  const below = y + POINTER_OFFSET_PX;
  const fitsBelow = below + height + VIEWPORT_MARGIN_PX <= viewportHeight;
  const top = fitsBelow
    ? below
    : Math.max(VIEWPORT_MARGIN_PX, y - POINTER_OFFSET_PX - height);
  return { left, top };
};
